<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="trextype_id" [ttModel]="edit.trextype_id" ttReadonly></tt-input>
        <tt-input ttLabel="trextype_lang_name" [(ttModel)]="edit.trextype_lang_name" ttRequired></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-select ttLabel="glyphicon" [(ttModel)]="edit.glyphicon" (ttModelChange)="onChanged($event, 'glyphicon')" [ttData]="selectListGlyphicons" ttDataId="item_id" ttDataName="item_name"></tt-select>

        <div *ngIf="edit.glyphicon.startsWith('fa-')">
            <pre><span class="fa" [ngClass]="edit.glyphicon" [style.font-size.px]="40" [style.color]="glyphiconColour"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('fab-')">
            <pre><span class="fab" [ngClass]="'fa-' + edit.glyphicon.slice(4)" [style.font-size.px]="40" [style.color]="glyphiconColour"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('fad-')">
            <pre><span class="fad" [ngClass]="'fa-' + edit.glyphicon.slice(4)" [style.font-size.px]="40" [style.color]="glyphiconColour"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('far-')">
            <pre><span class="far" [ngClass]="'fa-' + edit.glyphicon.slice(4)" [style.font-size.px]="40" [style.color]="glyphiconColour"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('fas-')">
            <pre><span class="fas" [ngClass]="'fa-' + edit.glyphicon.slice(4)" [style.font-size.px]="40" [style.color]="glyphiconColour"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('glyphicon-')">
            <pre><span class="glyphicon" [ngClass]="edit.glyphicon" [style.font-size.px]="40" [style.color]="glyphiconColour"></span></pre>
        </div>

        <tt-select ttLabel="businessco" [(ttModel)]="edit.businessco_no" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name" ttRequired></tt-select>
        <tt-search [hidden]="edit.businessco_no === '0'" ttLabel="account_name" [(ttModel)]="edit.account_name" [ttSearch]="searchAccountNames" (ttOnSelected)="onAccountNameSelected($event)" (ttOnClear)="onAccountNameSelected()" ttRequired></tt-search>
        <tt-button-save ttText="travexptype_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
